import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ModalUI from '../../../shared/components/Modal';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#000"
        },
    },
});

const no_op = () => { }
const FormAddAdvancePayment = ({ onEdit = false, setOnEdit = no_op, advanceToEdit = null, setAdvanceToEdit = no_op, getAdvancePayments = no_op }) => {
    const [concept, setConcept] = useState('');
    const [income, setIncome] = useState('');
    const [advancePaymentDate, setAdvancePaymentDate] = useState(null);
    const [paymentWay, setPaymentWay] = useState(null);
    const [thirds, setThirds] = useState(null);
    const [selectedThird, setSelectedThird] = useState(null);
    const [typeCard, setTypeCard] = useState('');
    const [transactionNumber, setTransactionNumber] = useState('');
    const user = JSON.parse(sessionStorage.getItem('usuario'));

    const [errors, setErrors] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        if (advanceToEdit !== null) {
            setSelectedThird(advanceToEdit.id_tercero);
            setIncome(advanceToEdit.valor);
            setConcept(advanceToEdit.concepto);
            setAdvancePaymentDate(advanceToEdit.fecha_creacion);
            setPaymentWay(advanceToEdit.metodo_pago.metodo_pago.medio);
            setTypeCard(advanceToEdit.metodo_pago.metodo_pago.tipo_tarjeta);
            setTransactionNumber(advanceToEdit.metodo_pago.metodo_pago.nro_transaccion);
        }
    }, [advanceToEdit])

    useEffect(() => {
        const listThirds = async () => {
            await fetch(`${process.env.REACT_APP_PUBLIC_URL}tercero/listar-terceros-indicadores`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                return response.json();
            }).then(data => {
                console.log("Thirds", data)
                setThirds(data);
            }).catch((error) => {
                console.log(error)
            });
        }

        listThirds();
    }, [])


    const validateForm = () => {
        const errors = {};
        var error = false;

        if (selectedThird == null) {
            errors.cliente = "Seleccione un Cliente";
            error = true;
        }

        if (income == "") {
            errors.valor_ingresado = "Ingrese el importe recibido";
            error = true;
        }

        if (concept == "") {
            errors.concepto = "Ingrese un concepto";
            error = true;
        }

        if (advancePaymentDate == null) {
            errors.fecha = "Seleccione una fecha";
            error = true;
        }


        if (paymentWay == '' || paymentWay == null) {
            errors.forma_pago = "Seleccione una forma de pago";
            error = true;
        }

        if (selectedThird == null) {
            errors.cliente = "Seleccione un cliente";
            error = true;
        }

        if (paymentWay === "Tarjeta") {
            if (typeCard == '') {
                errors.cardType = "Seleccione un tipo de tarjeta";
                error = true;
            }
        }

        if (paymentWay === "transaccion" || paymentWay === "Tarjeta") {
            if (transactionNumber == '') {
                errors.transactionNumber = "Digite el numero de transacción";
                error = true;
            }
        }


        console.log("ERRORSFORM", errors);
        setErrors(errors);
        return error;
    }

    const saveAdvacePayment = async () => {

        if (!validateForm()) {
            let dataSend = {
                id_tercero: selectedThird,
                valor: parseInt(income),
                anulacion: false,
                procesado: false,
                concepto: concept,
                id_usuario: user?.id_usuario,
                fecha_creacion: moment(advancePaymentDate).format('YYYY-MM-DD HH:mm:ss'),
                metodo_pago: {
                    medio: paymentWay,
                    monto: parseInt(income),
                    tipo_tarjeta: paymentWay === 'Tarjeta' ? typeCard : '',
                    nro_transaccion: paymentWay === "transaccion" || paymentWay === "Tarjeta" ? transactionNumber : ''
                }
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    console.log("PaymentSaved", data);
                    setConcept('');
                    setIncome('');
                    setAdvancePaymentDate(null);
                    setPaymentWay('');
                    setTypeCard('');
                    setTransactionNumber('');
                    setSelectedThird(null);
                    getAdvancePayments();
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.log(error)
                    setModalAlert({
                        message: "No se pudo guardar el pago",
                        color: 'danger',
                        title: "Error!"
                    });
                })
        }
    }

    const updateAdvacePayment = async () => {

        if (!validateForm()) {
            let dataSend = {
                id_anticipo: parseInt(advanceToEdit.id_anticipo),
                id_tercero: selectedThird,
                valor: parseInt(income),
                anulacion: false,
                procesado: false,
                concepto: concept,
                id_usuario: user?.id_usuario,
                fecha_creacion: moment(advancePaymentDate).format('YYYY-MM-DD HH:mm:ss'),
                metodo_pago: {
                    medio: paymentWay,
                    monto: parseInt(income),
                    tipo_tarjeta: paymentWay === 'Tarjeta' ? typeCard : '',
                    nro_transaccion: paymentWay === "transaccion" || paymentWay === "Tarjeta" ? transactionNumber : ''
                }
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    console.log("PaymentUpdated", data);
                    setConcept('');
                    setIncome('');
                    setAdvancePaymentDate(null);
                    setPaymentWay('');
                    setTypeCard('');
                    setTransactionNumber('');
                    setSelectedThird(null);
                    getAdvancePayments();
                    setOpenAlert(true);
                    setOnEdit(false);
                    setAdvanceToEdit(null);
                    setModalAlert({
                        message: "Actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.log(error)
                    setModalAlert({
                        message: "No se pudo actualizar el anticipo",
                        color: 'danger',
                        title: "Error!"
                    });
                })
        }
    }

    const onToggleCancelEdition = () => {
        setConcept('');
        setIncome('');
        setAdvancePaymentDate(null);
        setPaymentWay('');
        setTypeCard('');
        setTransactionNumber('');
        setSelectedThird(null);
        setOnEdit(false);
        setAdvanceToEdit(null);
    }
    return (
        <Fragment>
            {
                thirds &&
                <Row>
                    <Col>
                        <TextField
                            label="Clientes"
                            required
                            select
                            value={selectedThird}
                            InputLabelProps={{
                                style: { color: '#646777' },
                                shrink: true
                            }}
                            onChange={(event) => {
                                setSelectedThird(event.target.value)
                            }}
                            type="number"
                            className="medical-material-form__field"
                            error={errors.hasOwnProperty("cliente") ? errors.cliente !== "" : false}
                            helperText={errors.cliente}
                        >
                            <MenuItem key={0} value={null}></MenuItem>
                            {
                                thirds.map((third) => (
                                    <MenuItem key={third.id_tercero} value={third.id_tercero}>
                                        {third.nombre}
                                    </MenuItem>
                                ))
                            }
                        </TextField>
                    </Col>
                </Row>
            }
            <Row>
                <Col md={6}>
                    <TextField
                        label="Valor"
                        required
                        value={income}
                        onChange={(event) => {
                            setIncome(event.target.value)
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("valor_ingresado") ? errors.valor_ingresado !== "" : false}
                        helperText={errors.valor_ingresado}
                    />
                </Col>
                <Col md={6}>
                    <TextField
                        label="Concepto"
                        required
                        value={concept}
                        onChange={(event) => {
                            setConcept(event.target.value)
                        }}
                        type="text"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("concepto") ? errors.concepto !== "" : false}
                        helperText={errors.concepto}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <KeyboardDatePicker
                                required
                                disableFuture
                                label="Fecha del anticipo"
                                openTo="date"
                                variant="inline"
                                value={advancePaymentDate}
                                onChange={(date) => {
                                    setAdvancePaymentDate(date);
                                }}
                                format="DD/MM/YYYY"
                                animateYearScrolling
                                className="material-form__field"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                autoOk={true}
                                style={{ width: '100%' }}
                                error={errors.hasOwnProperty("fecha") ? errors.fecha !== "" : false}
                                helperText={errors.fecha}
                            />
                        </ThemeProvider>
                    </MuiPickersUtilsProvider>
                </Col>
                <Col md={6}>
                    <TextField
                        label="Forma de pago"
                        required
                        select
                        value={paymentWay}
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                        onChange={(event) => {
                            setPaymentWay(event.target.value)
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("forma_pago") ? errors.forma_pago !== "" : false}
                        helperText={errors.forma_pago}
                    >
                        <MenuItem key={1} value={'Efectivo'}>
                            Efectivo
                        </MenuItem>
                        <MenuItem key={2} value={'Tarjeta'}>
                            Tarjeta
                        </MenuItem>
                        <MenuItem key={3} value={'Cheque'}>
                            Cheque
                        </MenuItem>
                        <MenuItem key={4} value={'transaccion'}>
                            Transacción
                        </MenuItem>
                    </TextField>
                </Col>

            </Row>
            <Row>
                {
                    paymentWay === "Tarjeta" ?
                        <Col md={6}>
                            <TextField
                                select
                                label="Tipo de tarjeta"
                                name="cardType"
                                value={typeCard}
                                onChange={(event) => {
                                    setTypeCard(event.target.value)
                                }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                    style: { color: '#646777' },
                                    shrink: true
                                }}
                                required={true}
                                autoFocus
                                error={errors.hasOwnProperty("cardType") ? errors.cardType !== "" : false}
                                helperText={errors.cardType}
                            >
                                <MenuItem key={1} value={'Debito'}>
                                    Débito
                                </MenuItem>
                                <MenuItem key={2} value={'Credito'}>
                                    Crédito
                                </MenuItem>
                            </TextField>
                        </Col>
                        : null
                }
                {paymentWay === "transaccion" || paymentWay === "Tarjeta" ?
                    <Col md={6}>
                        <TextField
                            label="Nro. Transacción"
                            name="transactionNumber"
                            value={transactionNumber}
                            type="number"
                            onChange={(event) => {
                                setTransactionNumber(event.target.value);
                            }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' },
                                shrink: true
                            }}
                            required={true}
                            autoFocus
                            error={errors.hasOwnProperty("transactionNumber") ? errors.transactionNumber !== "" : false}
                            helperText={errors.transactionNumber}
                        />
                    </Col>
                    : null}
            </Row>
            <Row>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    {onEdit ?
                        <Button
                            style={{ marginRight: 10, marginTop: 10 }}
                            color="primary"
                            size="sm"
                            id="searchBtn"
                            onClick={() => {
                                onToggleCancelEdition();
                            }}
                        >
                            Cancelar Editar
                        </Button>
                        : null}
                    <Button
                        style={{ marginRight: 10, marginTop: 10 }}
                        color="primary"
                        size="sm"
                        id="searchBtn"
                        onClick={() => {
                            if (onEdit) {
                                updateAdvacePayment();
                            } else {
                                saveAdvacePayment();
                            }
                        }}
                    >
                        {onEdit ? 'Actualizar' : 'Guardar'}
                    </Button>
                </div>
            </Row>

            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment>
    )
}

export default FormAddAdvancePayment